module.exports = __webpack_public_path__ + "img/1020_1.77e5ebb5.jpg";